import { Navigate, useLocation } from 'react-router-dom';
import { LOGIN_CONST } from '../../common/constant/page-constants';
import { getCookieCustom } from '../../common/utils/StorageUItils';

export const isAuthenticated = () => Boolean(getCookieCustom(LOGIN_CONST.ACCESS_TOKEN));

const ProtectedRoute = ({ children }) => {
    const location = useLocation();

    if (!isAuthenticated()) {
        return <Navigate to="/" replace state={{ from: location }} />;
    }

    return children;
};

export default ProtectedRoute;
